const protocol = 'https://';
const rootURI = 'creditkey.com';

export const VERSION = '1.0.0';

export const platform = () => {
  if (process.env.NODE_ENV !== 'production') {
    return 'development';
  } else if (window.location && window.location.hostname.match(/staging/i)) {
    return 'staging';
  }

  return 'production';
};

export const server = (api = true) => {
  if (process.env && process.env.NODE_ENV !== 'production')
    return 'http://localhost:9100';

  let subDomain = 'www';
  if (window.location && window.location.hostname.match(/staging/i))
    subDomain = 'staging';

  const baseURI = protocol + subDomain + '.' + rootURI;

  return api ? `${baseURI}/app` : baseURI;
};

export const borrowerPortalUrl = () => `${server()}/dashboard/borrower`;
export const supportLink = 'https://creditkey.zendesk.com/hc/en-us';

export const emailRegex =
  // eslint-disable-next-line
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
